
import Mark from 'mark.js';
import ReactHtmlParser from 'react-html-parser';

export function capitalize(word) {
  return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
}

export function capitalizeProp(prop) {
  return (item) => {
    const itemClone = { ...item };

    itemClone[prop] = capitalize(itemClone[prop]);

    return itemClone;
  };
}

export function formatFilename(filename) {
  const extension = filename.split('.').pop();
  const name = filename.split('.').slice(0, -1).join('.');
  let retVal = filename;
  if (name.length > 10) {
    retVal = `${name.substring(0, 10)}...${extension}`;
  }

  return retVal;
}

export function titleCase(word) {
  return word.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export function highlightSearchedText(text, searchString) {
  const element = document.createElement('span');
  element.innerHTML = text;
  const instance = new Mark(element);
  instance.mark(searchString, {
    element: 'strong',
    separateWordSearch: false,
    diacritics: false,
  });
  return ReactHtmlParser(element.innerHTML);
}

export function removeAllWhiteSpace(string) {
  // This Regex matches all spaces, tabs, and new lines.
  return string.replace(/\s/g, '');
}

export function replaceUnderscoresWithSpaces(stringData) {
  return stringData.replace(/_/g, ' ');
}

export function formatCamelCaseToSpaces(camelCaseString) {
  return camelCaseString.split(/(?=[A-Z])/).join(' ');
}

export function replaceWhiteSpaceWithSpace(string) {
  return string.replace(/\s+/g, ' ');
}

export function replaceZeroWidthWhiteSpace(string) {
  return string.replace(/[\u200B-\u200D\uFEFF]/g, '');
}

export function removeSpecialCharacters(string) {
  return string.replace(/[^a-zA-Z0-9]/g, '');
}

export function luhnAlgorithm(cardNumberNoSpaces) {
  const arr = cardNumberNoSpaces
    .split('')
    .reverse()
    .map(x => parseInt(x, 10));

  const lastDigit = arr.splice(0, 1)[0];
  let sum = arr.reduce((acc, val, i) => (i % 2 !== 0 ? acc + val : acc + ((val * 2) % 9) || 9), 0);
  sum += lastDigit;

  return sum % 10 === 0;
}

/**
 * @function removePeriodsFromString
 * Remove all periods from a string.
 *
 * EXAMPLES:
 * '1.11'           --> "111"
 * '1.00'           --> "100"
 * 'hello.world.c'  --> "helloworldc"
 *
 * @param {String} string String to be processed.
 * @returns {String} original string with all periods ('.') removed.
 */
export const removePeriodsFromString = string => string.replace(/\./g, '');
